import React, { useEffect, useState } from 'react';
import Top from './top';
import Portfolio from './portfolio';
import Staff from './staff';

const Concept = ({ hallId, getConceptTop, getConceptStaff, getConceptPortfolio }) => {
    const [conceptTop, setConceptTop] = useState(null);
    const [conceptStaff, setConceptStaff] = useState(null);
    const [conceptPortfolio, setConceptPortfolio] = useState(null);

    const [errorMessages, setErrorMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        Promise.all([getConceptTop(hallId), getConceptStaff(hallId), getConceptPortfolio(hallId)])
            .then(([topResponse, staffResponse, portfolioResponse]) => {
                setConceptTop(topResponse.data);
                setConceptStaff(staffResponse.data);
                setConceptPortfolio(portfolioResponse.data);
            })
            .catch((error) => {
                setErrorMessages((prev) => [...prev, 'データの取得に失敗しました']);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [hallId]);

    if (isLoading) {
        return null;
    }

    const isEmpty = (array) => {
        return array && array.length === 0
    }
     
    if (
        isEmpty(conceptTop) ||
        conceptStaff && isEmpty(conceptStaff.staffs) ||
        errorMessages.length > 0
    ) {
        return (
            <div className="concept-intro">
                <div className="concept-intro__contents text--center">
                    <div className="section-heading">
                        <h1 className="section-heading__title color--accent font-family--large">MESSAGE</h1>
                        <p className="section-heading__sub font-family--middle">想い・メッセージ</p>
                    </div>
                    <p className="lead-text">表示できるコンテンツがありません。</p>
                </div>
            </div>
        );
    }

    return (
        <>
            {conceptTop && (
                <Top
                    main_concept={conceptTop.main_concept}
                    concept_text={conceptTop.concept_text}
                    main_concept_image={conceptTop.image.image_url}
                />
            )}
            {conceptPortfolio && conceptPortfolio.portfolios.length > 1 && (
                <Portfolio portfolios={conceptPortfolio.portfolios} />
            )}
            {conceptStaff && <Staff staffs={conceptStaff.staffs} />}
        </>
    );
};

export default Concept;
